'use client';

import { clsx } from 'clsx';
import { Listbox, ListboxOption, ListboxOptions } from '@headlessui/react';

import { SelectOption } from './SelectOption';

import type { SelectItem } from '../types';

export type SelectListProps<T> = {
  title?: string;
  data: Array<T>;
  value: T | Array<T> | undefined;
  onChange: (value: T | Array<T>) => void;
  className?: string;
};

export const SelectList = <T extends SelectItem>({
  title,
  data,
  value,
  onChange,
  className,
}: SelectListProps<T>) => {
  return (
    <div className={clsx('flex flex-col', className)}>
      {title && <span className='body font-bold mb-3 px-5'>{title}</span>}
      <Listbox value={value} onChange={onChange} multiple>
        <ListboxOptions static className='body font-light'>
          {data.map((item) => (
            <ListboxOption key={item.id} value={item}>
              {({ selected }) => (
                <SelectOption variant='column' selected={selected}>
                  {item.title}
                </SelectOption>
              )}
            </ListboxOption>
          ))}
        </ListboxOptions>
      </Listbox>
    </div>
  );
};
